import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AppMenuitem } from './app.menuitem';
import { AuthService } from '@/app/services/auth.service';

@Component({
    selector: 'app-menu',
    standalone: true,
    imports: [CommonModule, AppMenuitem, RouterModule],
    template: `
        <ul class="layout-menu">
            @for (item of model(); track item.label) {
                @if (!item.separator) {
                    <li app-menuitem [item]="item" [root]="true"></li>
                } @else {
                    <li class="menu-separator"></li>
                }
            }
        </ul>
    `,
})
export class AppMenu {
    private readonly authService = inject(AuthService);

    readonly model = computed<MenuItem[]>(() => {
        const isGlobal = this.authService.isGlobalAdmin();

        const websitesItems: MenuItem[] = [
            {
                label: 'List',
                icon: 'pi pi-fw pi-list',
                routerLink: ['/website'],
            },
        ];
        if (isGlobal) {
            websitesItems.push({
                label: 'Companies',
                icon: 'pi pi-fw pi-building',
                routerLink: ['/companies'],
            });
            websitesItems.push({
                label: 'Categories',
                icon: 'pi pi-fw pi-tags',
                routerLink: ['/categories'],
            });
            websitesItems.push({
                label: 'Site Templates',
                icon: 'pi pi-fw pi-clone',
                routerLink: ['/site-templates'],
            });
            websitesItems.push({
                label: 'Auth Presets',
                icon: 'pi pi-fw pi-sign-in',
                routerLink: ['/auth-presets'],
            });
        }

        const sections: MenuItem[] = [
            {
                label: 'Home',
                items: [
                    {
                        label: 'Dashboard',
                        icon: 'pi pi-fw pi-home',
                        routerLink: ['/'],
                    },
                ],
            },
            {
                label: 'Websites',
                items: websitesItems,
            },
            {
                label: 'Games',
                items: [
                    {
                        label: 'List',
                        icon: 'pi pi-fw pi-list',
                        routerLink: ['/game-templates'],
                    },
                ],
            },
            {
                label: 'Users',
                items: [
                    {
                        label: 'Manage',
                        icon: 'pi pi-fw pi-users',
                        routerLink: ['/users'],
                    },
                ],
            },
            {
                label: 'Finance',
                items: [
                    {
                        label: 'Invoices',
                        icon: 'pi pi-fw pi-receipt',
                        routerLink: ['/invoices'],
                    },
                    {
                        label: 'Invoices guide',
                        icon: 'pi pi-fw pi-book',
                        routerLink: ['/help/invoices'],
                    },
                ],
            },
            {
                label: 'Skins',
                items: [
                    {
                        label: 'Purchases',
                        icon: 'pi pi-fw pi-shopping-bag',
                        routerLink: ['/skins/purchases'],
                    },
                    {
                        label: 'Trade-ins',
                        icon: 'pi pi-fw pi-arrow-right-arrow-left',
                        routerLink: ['/skins/trade-ins'],
                    },
                ],
            },
        ];

        if (isGlobal) {
            sections.push({
                label: 'Automation (advanced)',
                items: [
                    {
                        label: 'Templates',
                        icon: 'pi pi-fw pi-file-edit',
                        routerLink: ['/automation/templates'],
                    },
                    {
                        label: 'Rules',
                        icon: 'pi pi-fw pi-sitemap',
                        routerLink: ['/automation/rules'],
                    },
                    {
                        label: 'Events',
                        icon: 'pi pi-fw pi-history',
                        routerLink: ['/automation/events'],
                    },
                ],
            });
            sections.push({
                label: 'Reviews',
                items: [
                    {
                        label: 'Fake authors',
                        icon: 'pi pi-fw pi-user',
                        routerLink: ['/reviews/fake-authors'],
                    },
                    {
                        label: 'Fake comments',
                        icon: 'pi pi-fw pi-comments',
                        routerLink: ['/reviews/fake-comments'],
                    },
                ],
            });
        }

        return sections;
    });
}
